import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=404aa237&scoped=true&lang=pug"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404aa237",
  null
  
)

export default component.exports